module.exports = __webpack_public_path__ + "app/assets/images/grey-bar.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/grey-bar.png
// module id = 1119
// module chunks = 7